import React from 'react'

const Testimonials = () => {
  return (
    <section className="bg-white ">
<div className='w-9/10 font-Elm-sans md:w-8/10 pt-3 md:pt-10 flex items-center flex-col justify-center'>
 <h1 className='p-1  md:p-3 mx-auto text-2xl md:text-5xl text-tertiary'> What Our Customers Are Saying</h1>
  <iframe src='https://widgets.sociablekit.com/google-reviews/iframe/25578136' frameborder='0' width='90%' height='500'></iframe>
  
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.1602668729056!2d3.2585099!3d6.627006499999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b9158cb952201%3A0xf6e7e59553538ee7!2sGoldyvhista%20Hubz%20kitchen%20and%20household%20items!5e0!3m2!1sen!2suk!4v1752496289969!5m2!1sen!2suk" className=" md:p-10" frameborder='0' width='100%' height='500'></iframe>
</div>
</section>
  )
}

export default Testimonials